import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { APP_Constants } from 'src/app/app.constant';
import { AppService } from 'src/app/app.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-additional-information-v2',
    templateUrl: './additional-information-v2.component.html',
    styleUrls: ['./additional-information-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdditionalInformationV2Component implements OnInit {

  constructor(private appService : AppService, private changeDetector : ChangeDetectorRef) { }
  
  toggleHide = false;
  orderMessageHide = false;
  @Input() additionalInfo;
  @Input() messageInfo;
  @Input() configData;
  @Input() Data;

  @Input() actionRequired;
  verificationDestLocData

  ngOnInit() {  
    console.log(this.additionalInfo);
  }

  isAction() {
    if(this.actionRequired == true){
      return true;
    }
    return false;
  }

  isLocation(){
    if(this.additionalInfo && !this.messageInfo){
      return true;
    }
    if(this.messageInfo && !this.additionalInfo){
      return false;
    }
  }

  getLocationData(data){
    let locationId;
    let key = data.name;
    if (data.name === 'verificationDestLocData') {
      this.verificationDestLocData = JSON.parse(localStorage.getItem('destinationLocationData'));
      let index = this.configData.name.split("vehicleDestinationDetails")[1];
      index = index ? index : 0;

      locationId = this.verificationDestLocData["destinationDetails" + index];
    } 
    else if(data.name === 'destLocData'){
      locationId = localStorage.getItem('locationData_1');      
    } else if(data.name === 'originLocData'){
      locationId = localStorage.getItem('locationData_0');      
    }

    locationId = locationId ? locationId : "NA";

    let locationIDUrl = APP_Constants.COX_LOCATION_SEARCH_BY_ID + locationId + '?userId=' + localStorage.getItem('userName') + '&customerCode=' + localStorage.getItem('customerCode') + '&action=fetchLocation';
    this.appService.makeHttpGetRequest(locationIDUrl).subscribe(location => {
      localStorage.setItem(key, JSON.stringify(location['data'].businessObject.location));

      this.toggleHide = true;
      this.changeDetector.detectChanges();

    }, err => {
      localStorage.setItem(key, "");
      this.toggleHide = true;
      this.changeDetector.detectChanges();
      console.log(err);
    });

  }

  getMessageData(data){
    this.orderMessageHide = true;
  }


}